<template>
  <DragPageProvider>
    <template #default="{ isDraggingInPage }">
      <DragAreaProvider :class="$attrs.class" :disabled @drop="handleDrop">
        <template #default="{ isDraggingInArea }">
          <slot
            :is-dragging-in-area="disabled ? false : isDraggingInArea"
            :is-dragging-in-page="disabled ? false : isDraggingInPage"
          />
        </template>
      </DragAreaProvider>
    </template>
  </DragPageProvider>
</template>

<script setup lang="ts">
import DragAreaProvider from './DragAreaProvider.vue'
import DragPageProvider from './DragPageProvider.vue'

const { disabled = false } = defineProps<{
  disabled?: boolean
}>()

const emit = defineEmits(['drop'])

function handleDrop(event: DragEvent) {
  if (!disabled) {
    emit('drop', event)
  }
}
</script>
